import { isEmpty } from 'lodash'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'
import { subcategoriesForCategory } from 'modules/expenses/hooks/useExpensesCustomization'
import { Expensable } from 'modules/expenses/types/Expensable'

export const buildMileageData = (
  expensable: Expensable,
  customizationFields: CustomizationField[],
  isOwnExpensable: boolean
) => {
  const showEmployeeInformation = !isOwnExpensable
  const employeeName = showEmployeeInformation ? expensable?.owner?.fullName : ''

  const mileageSubcategories = subcategoriesForCategory(
    customizationFields,
    'mileage',
    expensable?.mileage?.category?.id ?? '',
    { includeHidden: true }
  )

  const subcategoryLabel =
    mileageSubcategories.find(
      (subcategory) => subcategory.value === expensable?.mileage?.subcategory
    )?.label ?? ''

  const effectiveOn = expensable?.effectiveOn
    ? moment(expensable.effectiveOn).format('DD/MM/YYYY')
    : ''

  const items = [
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.information_block.expense_owner'),
      info: employeeName,
    },
    {
      title: i18n.t(
        'expenses_v2.confirmation_screen.expense.information_block.expense_subcategory'
      ),
      info: subcategoryLabel,
    },
    {
      title: i18n.t('expenses_v2.forms.fields.trip_date.label'),
      info: effectiveOn,
    },
  ]

  return items.filter(({ info }) => !isEmpty(info))
}
